/* DSL Rate-limit — voorkom dat dezelfde form binnen 30s opnieuw submit */
(function(){
  var KEY = "dsl_rl";
  function get(){ try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch(e){ return {}; } }
  function set(o){ try { localStorage.setItem(KEY, JSON.stringify(o)); } catch(e){} }
  document.addEventListener("submit", function(e){
    var f = e.target;
    if (!f.matches("[data-review-submit], #dsl-returns, .dsl-restock")) return;
    var k = f.id || f.dataset.formId || (f.action || "");
    var st = get();
    var now = Date.now();
    if (st[k] && (now - st[k]) < 30000) {
      e.preventDefault();
      if (window.DSL_BANNER) window.DSL_BANNER.show({text: "Even geduld — formulier is net verstuurd.", variant: "info"});
      return;
    }
    st[k] = now;
    set(st);
  }, true);
})();